import {
	IsString,
	IsBoolean,
	IsOptional,
	IsArray,
	ValidateNested,
	IsEnum,
	IsNotEmpty,
	Length,
	ValidateIf,
} from 'class-validator';
import { Transform, Type } from 'class-transformer';
import { FieldOptionDto } from './field-option.dto';
import { FieldOptionInterface } from '../../interfaces';
import { CustomFieldDataTypeEnum, ServiceTypeStatusEnum } from '../../enums';

export class CreateCustomFieldDto {
	@IsNotEmpty()
	districtId: string;

	@Length(1, 100, { message: 'Attribute Name is required' })
	name: string;

	@IsEnum(CustomFieldDataTypeEnum, { message: 'Data Type is required' })
	dataType: string;

	@Transform(({ value }) => {
		if (value === 'true') return true;

		if (value === 'false') return false;

		return value;
	})
	@IsBoolean({ message: 'Verification Type is required' })
	isRequired: boolean;

	@IsOptional()
	defaultFieldId?: string;

	@IsEnum(ServiceTypeStatusEnum, { message: 'Engagement Type is required' })
	engagementType?: string;

	@ValidateIf(
		(o) => o.dataType === CustomFieldDataTypeEnum.Options || o.dataType === CustomFieldDataTypeEnum.MultiSelect
	)
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => FieldOptionDto)
	options?: Array<FieldOptionInterface>;
}
